// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormVenue } from '~/utils/interface/venue';
import { EMPTY_STRING, REG_EXP } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormVenue> => {
  return yup.object().shape({
    id: yup.string().trim().optional(),
    name: yup
      .string()
      .trim()
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    address: yup
      .string()
      .trim()
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    email: yup
      .string()
      .trim()
      .test('isValidEmail', t('common_validate_invalid_email', { ns: 'common/base' }), (value) => {
        if (value && !REG_EXP.EMAIL.test(value)) return false;
        return true;
      })
      .optional(),
    phoneNumber: yup
      .string()
      .trim()
      .test('phone-length', t('common_validate_invalid_phone', { ns: 'common/base' }), (value) => {
        if (!value) return true;
        const phoneNumber = value?.replace(REG_EXP.NUMBER, EMPTY_STRING);
        return REG_EXP.PHONE_NUMBER.test(phoneNumber);
      })
      .optional(),
    city: yup.string().trim().optional(),
    state: yup.string().trim().optional(),
    zipCode: yup.string().trim().optional(),
    country: yup.string().trim().optional(),
    lat: yup.string().trim().optional(),
    lng: yup.string().trim().optional(),
    contactName: yup.string().trim().optional(),
    website: yup.string().trim().optional(),
    note: yup.string().trim().optional(),
    venueFile: yup.array().optional(),
    deleteFile: yup.boolean().optional(),
  });
};

export const defaultValuesVenueForm: IFormVenue = {
  id: EMPTY_STRING,
  name: EMPTY_STRING,
  email: EMPTY_STRING,
  address: EMPTY_STRING,
  city: EMPTY_STRING,
  state: EMPTY_STRING,
  zipCode: EMPTY_STRING,
  country: EMPTY_STRING,
  lat: EMPTY_STRING,
  lng: EMPTY_STRING,
  contactName: EMPTY_STRING,
  phoneNumber: EMPTY_STRING,
  website: EMPTY_STRING,
  note: EMPTY_STRING,
  venueFile: [],
};
